module.exports = __webpack_public_path__ + "static/media/19.59d83d09.jpg";